import { SocialProviderId } from "../socialPost/config";

/** CRA inyecta strings; acepta trim, BOM UTF-8, comillas y valores habituales. */
export const isEnvTruthy = (value: string | undefined): boolean => {
  if (value == null) return false;
  const v = value
    .trim()
    .replace(/^\uFEFF/, "")
    .replace(/^['"]+|['"]+$/g, "")
    .toLowerCase();
  return v === "true" || v === "1" || v === "yes" || v === "on";
};

const isEnvExplicitlyFalse = (value: string | undefined): boolean =>
  typeof value === "string" && value.trim() !== "" && !isEnvTruthy(value);

/**
 * TikTok como red para publicar (composer, grilla, publicaciones automáticas).
 * - **production**: oculto salvo `REACT_APP_TIKTOK_POSTING_ENABLED=true`
 * - **development**: visible salvo `REACT_APP_TIKTOK_POSTING_ENABLED=false`
 */
export const isTiktokPostingEnabled = (): boolean => {
  const raw = process.env.REACT_APP_TIKTOK_POSTING_ENABLED;
  if (isEnvTruthy(raw)) return true;
  if (isEnvExplicitlyFalse(raw)) return false;
  return process.env.NODE_ENV !== "production";
};

export const isTiktokSocialProviderId = (
  providerId: string | SocialProviderId | undefined
): boolean => {
  if (!providerId) return false;
  const normalized = String(providerId).toLowerCase().replace(/\s/g, "");
  return normalized === "tiktok" || normalized === SocialProviderId.TikTok.toLowerCase();
};

/**
 * YouTube como red para publicar (composer, integraciones, estadísticas mock).
 * - **production**: oculto salvo `REACT_APP_YOUTUBE_POSTING_ENABLED=true`
 * - **development**: visible salvo `REACT_APP_YOUTUBE_POSTING_ENABLED=false`
 */
export const isYoutubePostingEnabled = (): boolean => {
  const raw = process.env.REACT_APP_YOUTUBE_POSTING_ENABLED;
  if (isEnvTruthy(raw)) return true;
  if (isEnvExplicitlyFalse(raw)) return false;
  return process.env.NODE_ENV !== "production";
};

export const isYoutubeSocialProviderId = (
  providerId: string | SocialProviderId | undefined
): boolean => {
  if (!providerId) return false;
  const normalized = String(providerId).toLowerCase().replace(/\s/g, "");
  return normalized === "youtube" || normalized === SocialProviderId.YouTube.toLowerCase();
};

/**
 * Widget Crisp (script + sync de usuario).
 * - **production**: desactivado salvo `REACT_APP_CRISP_CHAT_ENABLED=true`
 * - **development**: activo salvo `REACT_APP_CRISP_CHAT_ENABLED=false`
 */
export const isCrispChatEnabled = (): boolean => {
  const raw = process.env.REACT_APP_CRISP_CHAT_ENABLED;
  if (isEnvTruthy(raw)) return true;
  if (isEnvExplicitlyFalse(raw)) return false;
  return process.env.NODE_ENV !== "production";
};
